module.exports = __webpack_public_path__ + "img/8_5.32f40aac.png";